import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const UnsetYoungChildrenMothersDialog = ({ studentId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleYoungChildrenMothersUnset = async () => {
    const body = { studentId };
    await dataProvider.customRequest(studentRequests.unsetYoungChildrenMother(), body, "PUT");
    refresh();
    notify(`Успешно отбелязахте студента като "Не е майка с малки деца"`, { type: "success" });
  };

  return (
    <ConfirmModal
      titleContent={"Майка с малки деца"}
      onConfirm={handleYoungChildrenMothersUnset}
      message={`Сигурни ли сте, че студента вече не е "Майка с малки деца"?`}
      triggerButton={
        <Button
          label="Не е майка с малки деца"
          variant="contained"
          startIcon={<BabyChangingStationIcon />}
          onClick={handleYoungChildrenMothersUnset}
        />
      }
    />
  );
};

export default UnsetYoungChildrenMothersDialog;
